import { TYPE_REGISTRASI_RAWAT_INAP } from "utils/registrations";
import TableListNoRencanaKontrol from "../TableListRencanaKontrol/TableListNoRencanaKontrol";
import { TUJUAN_KUNJUNGAN_KONSUL } from "./constants";
import React from "react";

const KondisiMunculTableListNoRencanaKontrol = ({
  formData,
  setFormData,
  type,
  setRowsRencanaKontrol,
  setShowModalRencanaKontrol,
  rowsRencanaKontrol,
  rowsRencanaKontrolUtama,
  setRowsRencanaKontrolUtama,
}) => {
  if (type === "RJ") {
    if (formData.tujuan_kunjungan === TUJUAN_KUNJUNGAN_KONSUL) {
      return (
        <TableListNoRencanaKontrol
          setShowModal={() => setShowModalRencanaKontrol(false)}
          formData={formData}
          setFormData={setFormData}
          rows={rowsRencanaKontrol}
          setRows={setRowsRencanaKontrol}
          rowsUtama={rowsRencanaKontrolUtama}
          setRowsUtama={setRowsRencanaKontrolUtama}
          isModal={false}
        />
      );
    } else {
      return <></>;
    }
  } else if (type === "RI") {
    return (
      <TableListNoRencanaKontrol
        setShowModal={() => setShowModalRencanaKontrol(false)}
        formData={formData}
        setFormData={setFormData}
        rows={rowsRencanaKontrol}
        rowsUtama={rowsRencanaKontrolUtama}
          setRowsUtama={setRowsRencanaKontrolUtama}
        type={TYPE_REGISTRASI_RAWAT_INAP}
        setRows={setRowsRencanaKontrol}
        isModal={false}
      />
    );
  } else {
    return <></>;
  }
};

export default KondisiMunculTableListNoRencanaKontrol;
